import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Select, Input, message, InputNumber, Icon, Upload, DatePicker} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice, APIS, config} from 'Utils';
import moment from "moment";
import {
    getGouXiaoUnitList,
    getDeliveryDetailList,
    getOrderDetail, saveOrder, listSecondList
} from "../../service/transportSplit";

class TransportSplitAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            channelCode: this.channelData.split('|')[1] || '',
            opts: ['创建二次配送'],
            selectedRowsAllKeys: [],
            selectedRowKeys: [],
            dataSource: [],
            secondCustList: [],
            gouxiaoUnitList: [],
            informationLi: [],
            rows: [],
            rowsOutSide: [],
            total: 1,
            userName: JSON.parse(window.localStorage.getItem('login_user_information')).userName,
            addSearchObj: {
                s: 10,
                p: 1,
                itemNum: '',
                itemDesc: '',
                transportOrder: '',
                orderNumber: '',
                salesUnitId: ''
            },
            detail: [],
            visible: false,
            loading: false,
            disabled: false,
            complete: true,
            submitParam: {
                id: '',
                customerId: JSON.parse(window.localStorage.getItem('login_user_information')).channelId,
                salesUnitId: '',
                secondCustId: '',
                lineList: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                orderNumber: '',
                remark: '',
                signMethod: '',
                signDate: ''
            }
        };
        this.pageChange = this.pageChange.bind(this);
        this.addPageChange = this.addPageChange.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onOutsideSelectChange = this.onOutsideSelectChange.bind(this);
        this.remarkChange = this.remarkChange.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        //hashHistory.push(url);
        window.open(`/pcweb/#${url}`);
    };

    goBack() {
        hashHistory.goBack();
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        });
    };

    /*删除*/
    deleteChange() {
        if (this.state.rowsOutSide.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        const ds = [...this.state.rows];
        const arr = ds.filter(item => !this.state.rowsOutSide.includes(item.uniqueFlag));
        const selected = [];
        arr.forEach(item => {
            selected.push(item.uniqueFlag)
        });
        this.setState({rows: arr, selectedRowsAllKeys: [...selected], rowsOutSide: []});
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}});
    }

    addPageChange(page, pageSize) {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, () => {
            this.addlist();
        });
    }

    /*
     列表选择改变事件
     */
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({rowsOutSide: selectedRowKeys});
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        let self = this;
        let channelCode = this.state.channelCode;
        self.setState({subDisabled: true});
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id.toString()
                    })
                }
                if (data.length == 1) {
                    this.state.detail.salesUnitId = res.data[0].id.toString();
                    this.state.submitParam.salesUnitId = res.data[0].id.toString();
                }
                self.setState({gouxiaoUnitList: arr}, () => {
                    const id = this.props.params.id;
                    if (id) {
                        this.getDetail(id);
                    } else {
                        self.setState({subDisabled: false});
                    }
                })
            }
        });

        listSecondList({p: 1, s: 10000, removeFlag: "0", status: "1"}).then((result) => { //获取客户管理
            if (result && result.code == 200) {
                this.setState({secondCustList: result.data});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });

    }

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    addlist() {
        if (this.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请先选择购货单位');
            return
        }
        let self = this;
        let obj = self.state.addSearchObj;
        self.setState({visible: true, loading: true});
        getDeliveryDetailList(obj).then(res => {
            if (res.code === 200) {
                const data = res.data;
                this.setState({
                    dataSource: data,
                    dataSourceTotal: res.total,
                    loading: false
                });
            }
        });
    }

    openAdd() {
        if (this.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请先选择购货单位');
            return
        }
        let self = this;
        self.setState({visible: true});
    }

    getDetail(id) {
        getOrderDetail(id).then(res => {
            if (res.code === 200) {
                const data = res.data;
                let arr = [];
                this.setState({
                    detail: data,
                    //rows: data.lineList,
                    submitParam: {
                        ...this.state.submitParam,
                        customerId: data.customerId,
                        salesUnitId: data.salesUnitId.toString(),
                        secondCustId: data.secondCustId,
                        signMethod: data.signMethod.toString(),
                        status: data.status,
                        remark: data.remark,
                        orderNumber: data.orderNumber,
                        signDate: data.signDate
                    },
                    addSearchObj: {
                        ...this.state.addSearchObj,
                        salesUnitId: data.salesUnitId
                    },
                    disabled: data.status == 0 ? false : true,
                    complete: data.status == 1 ? false : true,
                    informationLi: res.data.filePath ? [
                        {
                            uid: -2,
                            name: res.data.fileName,
                            status: 'done',
                            id: res.data.fileId,
                            url: `${config.server}${res.data.filePath.replace("getFile", "getFileDown")}`,
                            // thumbUrl: res.data.filePath ? `${config.server}${res.data.filePath}` : ''
                        }
                    ] : []
                });
                let rows = [];
                if (data.lineList) {
                    data.lineList.forEach(line => {
                        arr.push(line.deliveryDetailId);
                        var rowx = {
                            'uniqueFlag': line.deliveryDetailId,
                            'transportOrder': line.deliveryId,
                            'orderNumber': line.orderNumber,
                            'itemNum': line.itemNum,
                            'itemDesc': line.itemDesc,
                            'quantity': line.quantity,
                            'unSplitQuantity': line.unSplitQuantity,
                            'splitQuantity': line.splitQuantity,
                            'remark': line.remark
                        }
                        rows.push(rowx);
                    })
                }
                this.setState({selectedRowsAllKeys: arr, rows: rows, subDisabled: false});
                window.sessionStorage.setItem('transportSplit', JSON.stringify(data));
            }
        });
    }

    onSelectChangeGouHuoUnit = (item) => {
        this.state.submitParam.salesUnitId = item;
        this.state.addSearchObj.salesUnitId = item;
        this.state.detail.salesUnitId = item;
        const rows = this.state.rows;
        this.setState({
            submitParam: {...this.state.submitParam},
            detail: {...this.state.detail},
            rows: rows
        });
    }

    onSelectSecondCust = (item) => {
        this.state.submitParam.secondCustId = item;
        this.state.detail.secondCustId = item;
        const rows = this.state.rows;
        let customer = this.state.secondCustList.filter(x => x.id == item)[0];
        this.state.detail.phone = customer.phone;
        this.state.detail.eSignPhone = customer.phone;
        this.state.detail.address = customer.address;
        this.state.detail.custName = customer.name;
        this.state.detail.seller = customer.seller;
        this.state.detail.eSignLinkman = customer.seller;
        this.setState({
            submitParam: {...this.state.submitParam},
            detail: {...this.state.detail},
            rows: rows
        });
    }

    onSelectSignMethod = (item) => {
        this.state.submitParam.signMethod = item;
        this.state.detail.signMethod = item;
        const rows = this.state.rows;
        this.setState({
            submitParam: {...this.state.submitParam},
            detail: {...this.state.detail},
            rows: rows
        });
    }

    // 点击提交按钮
    submitHandle(type) {
        const id = this.props.params.id;
        var self = this;
        self.setState({subDisabled: true});
        let rowsData = this.state.rows;
        let rowList = [];
        if (rowsData.length == 0) {
            openNotice('warning', '请录入行信息！');
            self.setState({subDisabled: false});
            return;
        }
        if (self.state.detail.eSignPhone == null) {
            openNotice('warning', '联系电话不能为空！');
            self.setState({subDisabled: false});
            return;
        }
        if (self.state.detail.eSignLinkman == null) {
            openNotice('warning', '签署人不能为空！');
            self.setState({subDisabled: false});
            return;
        }
        for (let i = 0; i < rowsData.length; i++) {
            if (!rowsData[i].splitQuantity) {
                openNotice('warning', '数量不能为空！');
                self.setState({subDisabled: false});
                return;
            } else {
                let row = {};
                row.itemNum = rowsData[i].itemNum;
                row.itemDesc = rowsData[i].itemDesc;
                row.deliveryId = rowsData[i].transportOrder;
                row.orderNumber = rowsData[i].orderNumber;
                row.quantity = rowsData[i].quantity;
                row.deliveryDetailId = rowsData[i].uniqueFlag;
                row.remark = rowsData[i].remark;
                row.splitQuantity = rowsData[i].splitQuantity;
                row.unSplitQuantity = rowsData[i].unSplitQuantity;
                rowList.push(row);
            }
        }
        if (this.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请选择购货单位！');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.submitParam.secondCustId == '') {
            openNotice('warning', '请选择二级客户！');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.submitParam.signMethod == '') {
            openNotice('warning', '请选择是否发起电签！');
            self.setState({subDisabled: false});
            return;
        }
        if (type == 'complete' && self.state.submitParam.signDate == null) {
            openNotice('warning', '请填写签收日期后再完成！');
            self.setState({subDisabled: false});
            return;
        }
        if (type == 'complete' && self.state.informationLi.length == 0) {
            openNotice('warning', '请上传附件后再点击完成！');
            self.setState({subDisabled: false});
            return;
        }

        let data = this.state.submitParam;
        if (id) {
            data.id = id;
        }
        data.submitType = type;
        data.lineList = rowList;
        data.custName = this.state.detail.custName;
        data.phone = this.state.detail.phone;
        data.eSignPhone = this.state.detail.eSignPhone;
        data.address = this.state.detail.address;
        data.eSignLinkman = this.state.detail.eSignLinkman;
        data.fileId = this.state.informationLi.length > 0 ? this.state.informationLi[0].id : '';

        saveOrder(data).then((result) => {
            if (result && result.code == 200) {
                if (data.submitType == "commit") {
                    message.info("提交成功");
                    hashHistory.goBack();
                } else if (data.submitType == "complete") {
                    message.info("已完成");
                    hashHistory.goBack();
                } else {
                    message.info("保存成功");
                    const submitParam = self.state.submitParam;
                    submitParam.id = result.data.id;
                    submitParam.orderNumber = result.data.orderNumber;
                    self.setState({submitParam: submitParam});
                    window.sessionStorage.setItem('transportSplit', JSON.stringify(data));
                }
                self.setState({subDisabled: false});
            } else {
                message.error(result.message);
                self.setState({subDisabled: false});
            }
        });
    };


    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    addSave(record) {
        const {rows, selectedRowsAllKeys} = this.state;
        if (selectedRowsAllKeys.includes(record.uniqueFlag)) {
            openNotice('warning', '物料已添加');
            return
        }

        if (this.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请先选择购货单位');
            return
        }
        delete record.splitQuantity;
        this.setState({
            rows: [...rows, record],
            selectedRowsAllKeys: [...selectedRowsAllKeys, record.uniqueFlag]
        })
    }

    quantityChange = (record, index, e) => {
        let rows = this.state.rows;
        rows[index].splitQuantity = e;
        this.setState({rows: rows});
    }
    lineRemarkChange = (record, index, e) => {
        let rows = this.state.rows;
        rows[index].remark = e.target.value;
        this.setState({rows: rows});
    }

    remarkChange = (event) => {
        this.setState({
            submitParam: {...this.state.submitParam, remark: event.target.value}
        });
    };

    nameChange = (event) => {
        const addSearchObj = this.state.addSearchObj;
        addSearchObj.itemNum = event.target.value;
        this.setState({
            addSearchObj: addSearchObj
        });
    };
    transportChange = (event) => {
        const addSearchObj = this.state.addSearchObj;
        addSearchObj.transportOrder = event.target.value;
        this.setState({
            addSearchObj: addSearchObj
        });
    };

    keypress = (e) => {
        if (e.which == 13) {
            this.addlist();
        }
    }

    deleteInformation(index) {
        const {informationLi} = this.state;
        informationLi.splice(index, 1);
        this.setState({
            informationLi: informationLi
        });
    };

    signDateOnChange(date, dateString) {
        this.setState({
            submitParam: {...this.state.submitParam, signDate: date ? date.valueOf() : null}
        });
    }


    render() {
        var self = this;
        const {
            opts,
            rows,
            rowsOutSide,
            dataSource,
            dataSourceTotal,
            gouxiaoUnitList,
            secondCustList,
            total,
            detail,
            addSearchObj,
            visible,
            loading,
            submitParam,
            disabled,
            complete,
            informationLi
        } = this.state;
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'uniqueFlag',
            pageParam: {
                total: total,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '发运明细ID',
                    dataIndex: 'uniqueFlag'
                },
                {
                    title: '出库单号',
                    dataIndex: 'transportOrder'
                },
                {
                    title: '订单号',
                    dataIndex: 'orderNumber'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料名称',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '出库数量',
                    dataIndex: 'quantity'
                },
                {
                    title: '可用数量',
                    dataIndex: 'unSplitQuantity'
                },
                {
                    title: '本次数量',
                    dataIndex: 'splitQuantity',
                    render: (text, record, index) => {
                        return (<InputNumber style={{width: 100}} value={record.splitQuantity} disabled={disabled}
                                             max={record.unSplitQuantity}
                                             onChange={this.quantityChange.bind(this, record, index)}/>)
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => {
                        return (<Input style={{width: 100}} value={record.remark} disabled={disabled}
                                       onChange={this.lineRemarkChange.bind(this, record, index)}/>)
                    }
                }
            ],
            rows,
            rowSelection: {
                selectedRowKeys: rowsOutSide,
                onChange: this.onOutsideSelectChange
            }
        };

        let informationHtml = (informationLi || []).map(function (ele, key) {
            return <div className="edit_upload_information" key={key}>
                <span>{ele.fileName}</span>
                <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
            </div>
        });

        const informationProps = {
            fileList: [...informationLi],
            className: 'upload-img-only',
            listType: 'file',
            action: APIS.upload,
            onChange: (info) => {
                console.log(info);
                let fileList = info.fileList;
                fileList = fileList.slice(-1); //控制上传数量
                fileList = fileList.map((file) => {
                    if (file.response) {//上传成功后提取文件id 和 URL
                        file.url = `${config.server}${file.response.data.filePath.replace("getFile", "getFileDown")}`;
                        file.id = file.response.data.id;
                    }
                    return file;
                });
                fileList = fileList.filter((file) => {
                    if (file.response) {
                        return file.response.status; //当上传接口返回成功时才更新fileList
                    }
                    return true;
                });
                this.setState({informationLi: fileList});
            }

        };

        const addProps = {
            rowKey: 'uniqueFlag',
            loading: loading,//更新表格数据中
            pageParam: {
                total: dataSourceTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '发运明细ID',
                    dataIndex: 'uniqueFlag'
                },
                {
                    title: '出库单号',
                    dataIndex: 'transportOrder'
                },
                {
                    title: '订单号',
                    dataIndex: 'orderNumber'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料名称',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '出库数量',
                    dataIndex: 'quantity'
                },
                {
                    title: '可用数量',
                    dataIndex: 'unSplitQuantity'
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (
                        <Button style={{background: '#red'}} icon="plus"
                                onClick={this.addSave.bind(this, record)}>添加</Button>)
                }],
            rows: dataSource
        }

        return <div>
            <DmsTab options={opts} defaultKey={0}>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'commit')}
                        disabled={this.state.subDisabled || disabled}>提交</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'save')}
                        disabled={this.state.subDisabled || disabled}>保存</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'complete')}
                        disabled={this.state.subDisabled || complete || this.state.submitParam.signMethod == '1'}>完成</Button>
                {this.state.submitParam.orderNumber && <Button disabled={this.state.subDisabled}
                                                               onClick={this.goView.bind(this, '/transportSplitPrint')}>单据打印</Button>}
                <Button onClick={this.goBack}>返回</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Row style={{"height": "35px"}}>
                    <Col span={8}>
                        <p><label>单据编号：</label>
                            <span>{detail.orderNumber || submitParam.orderNumber}</span></p>
                    </Col>
                    < Col span={8}>
                        <p><label>单据日期：</label>
                            <span>{detail.createdDate ? moment(parseInt(detail.createdDate)).format('YYYY-MM-DD') : new Date().format('yyyy-MM-dd')}</span>
                        </p>
                    </Col>
                    <Col span={8}>
                        <p>
                            <label>状态：</label><span>{(detail.status || submitParam.status) == 1 ? '已提交' : (detail.status || submitParam.status) == 0 ? '保存' : (detail.status || submitParam.status) == 2 ? '已完成' : ''}</span>
                        </p>
                    </Col>
                </Row>
                <Row style={{"height": "35px"}}>
                    <Col span={8}>
                        <p><label className="ant-form-item-required">二级客户：</label>
                            <Select
                                value={this.state.submitParam.secondCustId}
                                placeholder="请选择二级客户"
                                style={{minWidth: 250}}
                                onSelect={this.onSelectSecondCust}
                                disabled={disabled}
                            >
                                {
                                    secondCustList.map((item, index) => {
                                        return <Select.Option key={item.id}
                                                              value={item.id}>{item.name}</Select.Option>
                                    })
                                }
                            </Select></p>
                    </Col>
                    <Col span={8}>
                        <p><label className="ant-form-item-required">购货单位：</label>
                            <Select
                                value={this.state.submitParam.salesUnitId}
                                placeholder="请选择购货单位"
                                style={{minWidth: 250}}
                                onSelect={this.onSelectChangeGouHuoUnit}
                                disabled={disabled}
                            >
                                {
                                    gouxiaoUnitList.map((item, index) => {
                                        return <Select.Option key={item.value}
                                                              value={item.value}>{item.text}</Select.Option>
                                    })
                                }
                            </Select></p>
                    </Col>
                    <Col span={8}>
                        <p><label className="ant-form-item-required">是否发起电签：</label>
                            <Select
                                value={this.state.submitParam.signMethod}
                                placeholder="请选择"
                                style={{minWidth: 250}}
                                onSelect={this.onSelectSignMethod}
                                disabled={disabled}
                            >
                                <Select.Option key={'1'} value={'1'}>是</Select.Option>
                                <Select.Option key={'0'} value={'0'}>否</Select.Option>
                            </Select></p>
                    </Col>

                </Row>
                <Row style={{"height": "35px"}}>
                    <Col span={8}>
                        <p><label>签署人：{detail.eSignLinkman}</label></p>
                    </Col>
                    <Col span={8}>
                        <p><label>收货地址：{detail.address}</label></p>
                    </Col>
                    <Col span={8}>
                        <p><label>联系电话：{detail.eSignPhone}</label></p>
                    </Col>
                </Row>
                <Row style={{"height": "35px"}}>
                    <Col span={16}>
                        <p><label>备注：</label>
                            <Input value={submitParam.remark} style={{width: 800}} onChange={this.remarkChange}
                                   disabled={disabled}/>
                        </p>
                    </Col>
                    < Col span={8}>
                        <p><label>签收日期：</label>
                            <DatePicker onChange={this.signDateOnChange.bind(this)}
                                        disabled={complete}
                                        value={submitParam.signDate ? moment(parseInt(submitParam.signDate)) : null}
                                        format={'YYYY-MM-DD HH:mm:ss'}/>
                        </p>
                    </Col>
                </Row>
                <Upload {...informationProps}>
                    <div style={{padding: '12px', background: '#fff'}}>
                        <Button disabled={complete}><Icon type="upload"/> 上传附件</Button>
                    </div>
                </Upload>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        <Button onClick={this.openAdd.bind(this)} disabled={disabled}>选择</Button>
                        <Button style={{marginLeft: 10}} onClick={this.deleteChange.bind(this)}
                                disabled={disabled}>删除</Button>
                    </div>
                    <TableView {...tableViewProps} />
                </div>
            </div>

            <Modal
                visible={visible}
                title="选择物料"
                onOk={this.handleOk.bind(this)}
                onCancel={this.handleCancel.bind(this)}
                maskClosable={false}
                width={1200}
            >
                <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                    <Row>
                        <Col span={8}><label>物料编码：</label><Input style={{width: 250}}
                                                                     value={this.state.addSearchObj.itemNum}
                                                                     onChange={this.nameChange.bind(this)}
                                                                     onKeyPress={this.keypress}/></Col>
                        <Col span={8}><label>出库单号：</label><Input style={{width: 250}}
                                                                     value={this.state.addSearchObj.transportOrder}
                                                                     onChange={this.transportChange.bind(this)}
                                                                     onKeyPress={this.keypress}/></Col>
                        <Col span={4}><Button onClick={this.addlist.bind(this)}>搜索</Button></Col>
                    </Row>
                    <div>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </div>
                </section>
            </Modal>

        </div>
    }
}
;
export default withRouter(TransportSplitAdd);


// WEBPACK FOOTER //
// ./src/routes/transportSplit/add.js